var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"d-flex"},[_vm._t("default"),_c('icon-button',{directives:[{name:"show",rawName:"v-show",value:(_vm.showIcon),expression:"showIcon"}],staticClass:"align-self-center",attrs:{"icon":_vm.icon},on:{"click":_vm.onIconButtonClick}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }